import { useState } from 'react'
import { useActionless } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import PinService from 'services/pin.service'
import ToastService from 'services/toast.service'

import { OWNED } from 'types/deck'
import { CardType } from 'types/deck'

import PhatButton from 'components/formElements/PhatButton'
import Icon from 'components/elements/Icon'
import SimpleSpinner from 'components/elements/SimpleSpinner'

import styles from './addToPins.module.scss'

type Props = {
  card: CardType
  onCardUpdated: (card: CardType) => void
  label?: string
  alwaysAddNewRecord?: boolean
}

const AddToPinsButton = ({ card, onCardUpdated, label = '', alwaysAddNewRecord = false }: Props) => {
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)
  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    if (card.pinnedStatus !== OWNED.NO && !alwaysAddNewRecord)
      return setActiveState({ pinnedCardsOverlay: true, pinnedCardsFilteredCards: [card.name] })

    setLoading(true)
    PinService.add(card)
      .then(() => {
        onCardUpdated({ ...card, pinnedStatus: card.cardId === card.cardId ? OWNED.YES : OWNED.PRINTING })
        ToastService.create(`Pinned ${card.name}`, 'Pinned Cards', 'success')
      })
      .catch(err => ToastService.create(err.error, 'Pinned Cards', 'error'))
      .finally(() => setLoading(false))
  }

  return (
    <PhatButton onClick={handleClick}>
      {!loading && (
        <>
          {card.pinnedStatus !== OWNED.NO ? (
            <span
              className={`${styles.ownedCollectionDot} ${card.pinnedStatus === OWNED.YES ? styles.greenDot : ''}`}
            />
          ) : (
            <Icon name="pin" />
          )}
          {card.pinnedStatus === OWNED.NO || alwaysAddNewRecord ? label || 'Pin card' : 'View pinned card'}
        </>
      )}

      {loading && (
        <>
          <SimpleSpinner size="medXSmall" /> Pin card
        </>
      )}
    </PhatButton>
  )
}

export default AddToPinsButton
